import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { GameSummary } from '@/lib/types';
import { GameList } from '@/components/GameList';

export function Games() {
    const [games, setGames] = useState<GameSummary[] | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        api.get<{ data: GameSummary[] }>('/games')
            .then((res) => {
                if (!cancelled) setGames(res.data.data);
            })
            .catch((e) => {
                if (!cancelled) {
                    setError(extractMessage(e));
                    setGames([]);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="lobby">
            <div className="lobby-banner">
                <h1>OPEN GAMES</h1>
                <p>Tap Join to buy a card or enter a live draw</p>
            </div>
            {error && <div className="lobby-empty">{error}</div>}
            {games === null && <div className="lobby-empty">Loading games…</div>}
            {games && <GameList games={games} />}
        </div>
    );
}

function extractMessage(error: unknown): string {
    if (typeof error === 'object' && error !== null && 'response' in error) {
        const res = (error as { response?: { data?: { message?: string } } }).response;
        if (res?.data?.message) return res.data.message;
    }
    return error instanceof Error ? error.message : 'Unknown error';
}
